import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { CircularProgress, Grid } from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import jMoment from "moment-jalaali";
import JalaliUtils from "@date-io/jalaali";
import useStyles from "../../Activity/components/AddEditActivity/style";
import TextFieldComponent from "components/TextField";
import UploadFile from "screens/Activity/components/AddEditActivity/components/UploadFile";
import CircularPercent from "screens/Activity/components/AddEditActivity/components/CircularPercent";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Axios from "screens/EnghelabSchoolForm/axios";
import CloseIcon from "@mui/icons-material/Close";
import ConvertPersianNumToLatin from "utilize/ConvertPersianNumToLatin";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: "80%",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  borderRadius: 5,
  boxShadow: 24,
  p: 4,
  overflowY: "scroll",
  height: "75vh",

  "& .MuiGrid-item": {
    marginBottom: 1,
    marginLeft: 2,
    display: "flex",
    flexDirection: "column",
  },
  "& .MuiGrid-item label": {
    fontSize: "1.2em",
    marginBottom: 1,
  },
  "& .MuiTypography-h6": {
    fontFamily: "iranSans",
  },
};
export default function AddActivityModalVerses(props) {
  const classes = useStyles();
  const [croppedImage, setCroppedImage] = useState([]);
  const [video, setVideo] = useState([]);
  const [document, setDocument] = useState([]);
  const [files, setFiles] = useState([]);
  const [removeFiles, setRemoveFiles] = useState([]);
  const [removeFilesId, setRemoveFilesId] = useState([]);
  const [registerLoading, setRegisterLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [subject, setSubject] = useState(0);
  const [mainTarget, setTarget] = useState("");

  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");

  const [selectedDateStart, handleDateChangeStart] = useState(moment());
  const [selectedDateEnd, handleDateChangeEnd] = useState(moment());
  const [startDateId, setStartDateId] = useState("");
  const [endDateId, setEndDateId] = useState("");

  const onUploadProgress = (e) => {
    setProgress(Math.floor((e.loaded * 100) / e.total));
  };
  const closeModalHandler = () => {
    try {
      setCroppedImage([]);
      setVideo([]);
      setDocument([]);
      setFiles([]);
      setRemoveFiles([]);
      setRemoveFilesId([]);
      setTitle("");
      setLocation("");
      setDescription("");
      setSubject(0);
      setTarget("");
      // setStartDateId("");
      // setEndDateId("");
      setProgress(0);
      setRegisterLoading(false);
      props.close();
    } catch (error) {}
  };
  const handleSubmit = async () => {
    try {
      if (title.length === 0) {
        return toast.error("عنوان نمی‌تواند خالی باشد");
      } else if (location.length === 0) {
        return toast.error("مکان اجرا نمی‌تواند خالی باشد");
      } else if (subject === 0 || subject === "") {
        return toast.error("موضوع نمی‌تواند خالی باشد");
      } else if (mainTarget === "") {
        return toast.error("مخاطب کنش نمی‌تواند خالی باشد");
      } else if (description.length === 0) {
        return toast.error("شرح برگزاری نمی‌تواند خالی باشد");
      }
      // if (role?.length === 0) {
      //   setRole((prev) => Roles?.[0]?.id);
      //   // console.log(role, Roles?.[0]?.id);
      // }
      var formData = new FormData();
      formData.append("actor", props.role?.[0]?.id);
      formData.append("title", title.trim());
      formData.append("category", "112"); //زندگی با آیه ها

      formData.append("subjects", subject);
      croppedImage.forEach((item) => {
        formData.append("new_file", item);
      });
      video.forEach((item) => {
        formData.append("new_file", item);
      });
      // document.forEach((item) => {
      //   formData.append("new_file", item);
      // });

      formData.append("boss_was_present", "");
      formData.append("school", "");
      formData.append("location", location);
      formData.append("start_date", startDateId?.toString());
      formData.append("finish_date", startDateId?.toString());

      const trgt = `مخاطب کنش: #${mainTarget.replace(' ','_')}\n`;
      let tDesc =   trgt + description;
      formData.append("description", tDesc);
      formData.append("derived_from", "");
      console.log(tDesc);
      const allMem = [
        // ...props.memberList,

        {
          user_id: props.user?.userId,
          slug: props.user?.slug,
          name: props.user?.name,
        },
        ,
      ];

      allMem.forEach((item) => {
        formData.append("cooperators", item.user_id);
      });
      // dispatch(activityRegister(formData, onUploadProgress));
      setRegisterLoading(true);

      const { data } = await Axios.post(
        "a/act/activity-register/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        onUploadProgress,
      );
      setRegisterLoading(false);
      toast.success("کنش با موفقیت ثبت شد");
      props.close();
      // if (data?.slug) {
      //   setRegisterLoading(false);

      //   await Axios.post("a/enghelab-school/group/activity-history/", {
      //     group: localStorage.getItem("enghelabSchoolId"),
      //     activity_slug: data?.slug,
      //     step: props.step.step - 1,
      //     step_name: props.step.title,
      //     actName: title,
      //     creator: {
      //       name: CurrentUser?.name,
      //       slug: CurrentUser?.slug,
      //     },
      //   });
      //   props.goForRefresh();
      //   toast.success("فعالیت با موفقیت ثبت شد");
      //   closeModalHandler();
      // }
      // console.log(data);
    } catch (error) {
      setRegisterLoading(false);
      toast.error("در ثبت فعالیت خطایی رخ داد. ورودی های خود را مجدد چک کنید");
      console.log(error);
    }
  };
  useEffect(() => {
    try {
      setStartDateId(
        ConvertPersianNumToLatin(
          new Date(Date.now())
            .toLocaleString("fa-IR")
            .substring(0, 10)
            .replaceAll("/", "-")
            .toString(),
        ).replaceAll("،", ""),
      );

      setEndDateId(
        ConvertPersianNumToLatin(
          new Date(Date.now())
            .toLocaleString("fa-IR")
            .substring(0, 10)
            .replaceAll("/", "-"),
        ).replaceAll("،", ""),
      );
    } catch (error) {}
  }, []);

  useEffect(() => {
    try {
      if (selectedDateStart._d.toLocaleString("fa-IR")?.length > 2) {
        setStartDateId(
          ConvertPersianNumToLatin(
            selectedDateStart._d
              .toLocaleString("fa-IR")
              .substring(0, 10)
              .replaceAll("/", "-")
              .toString(),
          ).replaceAll("،", ""),
        );
      } else {
        setStartDateId(
          ConvertPersianNumToLatin(
            new Date(Date.now())
              .toLocaleString("fa-IR")
              .substring(0, 10)
              .replaceAll("/", "-")
              .toString(),
          ).replaceAll("،", ""),
        );
      }
    } catch (error) {}
  }, [selectedDateStart]);

  useEffect(() => {
    try {
      if (selectedDateEnd.toLocaleString("fa-IR")?.length > 2) {
        setEndDateId(
          ConvertPersianNumToLatin(
            selectedDateEnd._d
              .toLocaleString("fa-IR")
              .substring(0, 10)
              .replaceAll("/", "-"),
          ).replaceAll("،", ""),
        );
      } else {
        setEndDateId(
          ConvertPersianNumToLatin(
            new Date(Date.now())
              .toLocaleString("fa-IR")
              .substring(0, 10)
              .replaceAll("/", "-"),
          ).replaceAll("،", ""),
        );
      }
    } catch (error) {}
  }, [selectedDateEnd]);
  // useEffect(() => {
  //   try {
  //     if (
  //       // params.edit !== "edit-activity" &&
  //       selectedDateStart._d > selectedDateEnd._d
  //     )
  //       handleDateChangeEnd(selectedDateStart);
  //   } catch (error) {}
  // }, [selectedDateStart]);
  // const Roles = useSelector((state) => state?.main?.currentUser?.roles);
  // const CurrentUser = useSelector((state) => state?.main?.currentUser);
  // useEffect(() => {
  //   // if (Roles?.length === 1) {
  //   setRole(Roles?.[0]?.id);
  //   console.log(Roles?.[0]?.id);
  //   // }
  // }, [Roles]);
  return (
    <Modal open={props.open} onClose={closeModalHandler}>
      <React.Fragment>
        <Box sx={style}>
          <Grid item style={{ flexDirection: "row" }}>
            <Button onClick={closeModalHandler}>
              <CloseIcon />
            </Button>
            <h1>ثبت کنش جدید</h1>
          </Grid>
          <Grid container spacing={2} className="addActivityForm">
            <Grid item>
              <Grid
                item
                className={classes.fieldTitleContainer}
                style={{ flexDirection: "row" }}
              >
                <Typography variant="h6" style={{ fontSize: "1.2em" }}>
                  عنوان
                </Typography>
                <Grid item className={classes.star2}>
                  *
                </Grid>
              </Grid>
              <input
                type="text"
                placeholder="عنوان کنش"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
              />
            </Grid>
            <Grid item>
              <Grid
                item
                className={classes.fieldTitleContainer}
                style={{ flexDirection: "row" }}
              >
                <Typography variant="h6" style={{ fontSize: "1.2em" }}>
                  مخاطب کنش
                </Typography>
                <Grid item className={classes.star2}>
                  *
                </Grid>
              </Grid>
              <select
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  boxShadow: "0 3px 31px 0 rgba(0, 0, 0, 0.15)",
                  padding: 13,
                  borderRadius: 5,
                  fontFamily: "iranSans",
                }}
                onChange={(e) => {
                  setTarget(e.target.value);
                }}
              >
                <option value="">انتخاب مخاطب</option>
                <option value="خانواده">خانواده</option>
                <option value="اعضای مدرسه">اعضای مدرسه</option>
                <option value="اعضای انجمن اسلامی">اعضای انجمن اسلامی </option>
              </select>
            </Grid>
            <Grid item>
              <Grid
                item
                className={classes.fieldTitleContainer}
                style={{ flexDirection: "row" }}
              >
                <Typography variant="h6" style={{ fontSize: "1.2em" }}>
                  مکان اجرا
                </Typography>
                <Grid item className={classes.star2}>
                  *
                </Grid>
              </Grid>
              <input
                type="text"
                placeholder="مکان اجرا"
                value={location}
                onChange={(e) => {
                  setLocation(e.target.value);
                }}
              />
            </Grid>
            <Grid item>
              <Grid
                item
                className={classes.fieldTitleContainer}
                style={{ flexDirection: "row" }}
              >
                <Typography variant="h6" style={{ fontSize: "1.2em" }}>
                  قالب
                </Typography>
                <Grid item className={classes.star2}>
                  *
                </Grid>
              </Grid>
              <input type="text" disabled value={"عملیات رمضان المبارک"} />
            </Grid>
            <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
              <Grid
                container
                justify="center"
                item
                md={4}
                className={`${classes.grid} add_activity_start_date`}
                style={
                  {
                    // marginTop: 20,
                  }
                }
              >
                <Grid
                  item
                  className={classes.fieldTitleContainer}
                  style={{ flexDirection: "row" }}
                >
                  <Typography variant="h6" style={{ fontSize: "1.2em" }}>
                    تاریخ آغاز
                  </Typography>
                  <Grid item className={classes.star2}>
                    *
                  </Grid>
                </Grid>

                <DatePicker
                  clearable
                  disableFuture
                  okLabel={<div className={classes.primaryBtn}>تایید</div>}
                  cancelLabel={<div className={classes.cancelBtn}>لغو</div>}
                  clearLabel={<></>}
                  labelFunc={(date) =>
                    date ? date.format("jYYYY/jMM/jDD") : ""
                  }
                  value={selectedDateStart}
                  onChange={handleDateChangeStart}
                  DialogProps={{ className: classes.dateDialog }}
                  TextFieldComponent={(props) => (
                    <TextFieldComponent {...props} />
                  )}
                />
              </Grid>
            </MuiPickersUtilsProvider>

            <Grid item>
              <Grid
                item
                className={classes.fieldTitleContainer}
                style={{ flexDirection: "row" }}
              >
                <Typography variant="h6" style={{ fontSize: "1.2em" }}>
                  موضوع
                </Typography>
                <Grid item className={classes.star2}>
                  *
                </Grid>
              </Grid>
              <select
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  boxShadow: "0 3px 31px 0 rgba(0, 0, 0, 0.15)",
                  padding: 13,
                  borderRadius: 5,
                  fontFamily: "iranSans",
                }}
                onChange={(e) => {
                  setSubject(e.target.value);
                }}
              >
                <option value="">انتخاب موضوع</option>
                <option value="276">فضاسازی قرآنی خانه</option>
                <option value="277">سفره های قرآنی</option>
                <option value="278">پانتومیم آیه ها</option>
                <option value="279">
                  قصه های قرآنی برای خواهران و برادران کوچکتر
                </option>
                <option value="280">آیه در صبحگاه</option>
                <option value="281">آیه روی تخته</option>
                <option value="282">
                  آیه در اتاق معلمان و فضای عمومی مدرسه
                </option>
                <option value="283">جنگ قرآنی</option>
                <option value="284">تریبون آزاد قرآنی</option>
                <option value="285">نامه ای به خدا</option>
                <option value="286">محفل انس با قرآن</option>
                <option value="287">افطاری ساده</option>
              </select>
            </Grid>
            {/* <Grid item xs={12}>
              <h2>شرکت کنندگان</h2>
              <div className="MemberListSection__Table">
                <table>
                  <thead>
                    <tr>
                      <th>ردیف</th>
                      <th>نام و نام خانوادگی</th>
                      <th>نقش</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props?.memberList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.name}</td>
                          <td>{item.role}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Grid> */}

            <Grid item xs={12} direction="column">
              <Grid
                item
                className={classes.fieldTitleContainer}
                style={{ flexDirection: "row" }}
              >
                <Typography variant="h6" style={{ fontSize: "1.2em" }}>
                  شرح برگزاری کنش
                </Typography>
                <Grid item className={classes.star2}>
                  *
                </Grid>
              </Grid>
              <textarea
                placeholder="توضیحات برگزاری کنش خود را اینجا بنویسید"
                style={{ height: 100 }}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </Grid>
            <Grid item xs={12} direction="column">
              <UploadFile
                croppedImage={croppedImage}
                setCroppedImage={setCroppedImage}
                video={video}
                setVideo={setVideo}
                files={files}
                removeFiles={removeFiles}
                setRemoveFiles={setRemoveFiles}
                document={document}
                setDocument={setDocument}
              />
            </Grid>
            <Grid
              container
              alignItems="center"
              // direction="row-reverse"
              className={classes.padding30}
              style={{ justifyContent: "center" }}
            >
              <Button
                variant="contained"
                // classes={{ disabled: classes.addActivityButtonDisabled }}
                className={`${classes.addActivityButton} add_activity_save`}
                onClick={handleSubmit}
                disabled={registerLoading}
                style={{
                  fontFamily: "iranSans",
                }}
                sx={{
                  "& button": {
                    fontFamily: "iranSans",
                  },
                }}
              >
                ثبت کنش
              </Button>
              {/* <Hidden mdUp>
                {registerLoading && (
                  <Grid item style={{ fontWeight: "bold", marginLeft: 10 }}>
                    منتظر بمانید
                  </Grid>
                )}
              </Hidden> */}
            </Grid>
          </Grid>
        </Box>
      </React.Fragment>
    </Modal>
  );
}
